import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_INFO_CARDS_START, DELETE_INFO_CARDS_ERROR, DELETE_INFO_CARDS_SUCCESS, GET_INFO_CARDS_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/info-cards/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_INFO_CARDS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_INFO_CARDS_ERROR, error });
  } finally {
    yield put({ type: GET_INFO_CARDS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_info_cards() {
  yield takeLatest(DELETE_INFO_CARDS_START, del);
}
